import { Component, HostListener } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { environment } from 'environments/environment';
import { GoogleAnalyticsService } from 'ngx-google-analytics';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    showScrollTop = false;

    constructor(
        private router: Router,
        protected $gaService: GoogleAnalyticsService
    ) {
        this.router.events.subscribe((event: Event) => {
            if (
                event instanceof NavigationEnd &&
                environment.NODE_ENV === 'production'
            ) {
                this.$gaService.pageView(event.url);
            }
        });
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        // Show scroll-to-top button when scrolled more than 300px
        this.showScrollTop = window.scrollY > 300;
    }

    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}
